import { Component } from '@angular/core';

@Component({
  selector: 'ciao-check-in-icon',
  imports: [],
  templateUrl: './check-in-icon.component.html',
})
export class CheckInIconComponent {}
